var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4958 9.99998C42.3305 13.9405 44 18.7752 44 24C44 29.2247 42.3305 34.0595 39.4958 38M31.4906 16C33.0724 18.2676 34 21.0255 34 24C34 26.9745 33.0724 29.7323 31.4906 32M19.2686 10.7313L12.9373 17.0627C12.5914 17.4086 12.4184 17.5816 12.2166 17.7053C12.0376 17.8149 11.8425 17.8957 11.6385 17.9447C11.4083 18 11.1637 18 10.6745 18H7.2C6.0799 18 5.51984 18 5.09202 18.218C4.71569 18.4097 4.40973 18.7157 4.21799 19.092C4 19.5198 4 20.0799 4 21.2V26.8C4 27.9201 4 28.4801 4.21799 28.908C4.40973 29.2843 4.71569 29.5902 5.09202 29.782C5.51984 30 6.07989 30 7.2 30H10.6745C11.1637 30 11.4083 30 11.6385 30.0552C11.8425 30.1042 12.0376 30.185 12.2166 30.2947C12.4184 30.4184 12.5914 30.5913 12.9373 30.9372L19.2686 37.2686C20.1254 38.1254 20.5538 38.5537 20.9215 38.5827C21.2407 38.6078 21.5525 38.4786 21.7604 38.2352C22 37.9547 22 37.3489 22 36.1372V11.8627C22 10.6511 22 10.0453 21.7604 9.76474C21.5525 9.52133 21.2407 9.39216 20.9215 9.41727C20.5538 9.44622 20.1254 9.87459 19.2686 10.7313Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.5c53a8d8b265cb99cd0aac73c6be763a.svg";
export { ForwardRef as ReactComponent };